<script setup lang="ts">
import Navbar from './components/navbar/navbar.vue'
import Footer from './components/footer/footer.vue'
import LanguageFAB from './components/LanguageFAB.vue'
import { useHead } from '@unhead/vue'
import { onMounted, computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'

const Toast = defineAsyncComponent(() => import('primevue/toast'))

const route = useRoute()

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Efes Tech',
  url: 'https://efestech.com',
  logo: 'https://efestech.com/logo.png',
  description:
    'Efes Tech, iOS ve Android mobil uygulama geliştirme, web uygulama geliştirme ve özel yazılım çözümleri sunan profesyonel bir yazılım şirketidir.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'YAKUPLU MAH. HÜRRİYET BLV. SKYPORT Skyport Residence Kapı No:1 Daire No:62',
    addressLocality: 'Beylikdüzü',
    addressRegion: 'İstanbul',
    postalCode: '34524',
    addressCountry: 'TR',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+90-536-788-4450',
    contactType: 'customer service',
    email: 'admin@efestech.com',
  },
  sameAs: [
    'https://www.linkedin.com/company/efes-bilgi-teknolojileri',
    'https://www.instagram.com/efestech',
    'https://youtube.com/@efestech',
    'https://www.tiktok.com/@efestechcom',
  ],
  offers: [
    {
      '@type': 'Offer',
      name: 'iOS Uygulama Geliştirme',
      description: 'Swift ve SwiftUI ile native iOS uygulamaları geliştirme hizmeti',
    },
    {
      '@type': 'Offer',
      name: 'Android Uygulama Geliştirme',
      description: 'Kotlin ve Jetpack Compose ile modern Android uygulamaları geliştirme hizmeti',
    },
    {
      '@type': 'Offer',
      name: 'Web Uygulama Geliştirme',
      description:
        'Vue.js, React ve modern web teknolojileri ile web uygulamaları geliştirme hizmeti',
    },
  ],
}

// Varsayılan meta etiketleri
useHead(() => ({
  title: 'Efes Tech - iOS, Android ve Web Uygulama Geliştirme',
  meta: [
    {
      name: 'description',
      content:
        'Efes Tech, iOS ve Android mobil uygulama geliştirme, web uygulama geliştirme ve özel yazılım çözümleri sunan profesyonel bir yazılım şirketidir.',
    },
    {
      name: 'keywords',
      content:
        'iOS uygulama geliştirme, Android uygulama geliştirme, mobil uygulama, web uygulama, Flutter, SwiftUI, Kotlin, Vue.js, React, özel yazılım',
    },
    {
      property: 'og:title',
      content: 'Efes Tech - iOS, Android ve Web Uygulama Geliştirme',
    },
    {
      property: 'og:description',
      content:
        'iOS, Android ve web uygulamaları geliştiriyoruz. Modern teknolojiler ile özel yazılım çözümleri sunuyoruz.',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:url',
      content: `https://efestech.com${route.path}`,
    },
    {
      property: 'og:image',
      content: 'https://efestech.com/og-image.jpg',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      name: 'twitter:title',
      content: 'Efes Tech - iOS, Android ve Web Uygulama Geliştirme',
    },
    {
      name: 'twitter:description',
      content:
        'iOS, Android ve web uygulamaları geliştiriyoruz. Modern teknolojiler ile özel yazılım çözümleri sunuyoruz.',
    },
    {
      name: 'twitter:image',
      content: 'https://efestech.com/og-image.jpg',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: `https://efestech.com${route.path}`,
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify(jsonLd),
    },
  ],
}))

onMounted(() => {
  // Asynchronously load primeicons with font-display: swap
  import('@/assets/primeicons.css')
})
</script>

<template>
  <div class="app-container">
    <Navbar />
    <div class="content">
      <router-view></router-view>
    </div>
    <Footer />
    <Toast />
    <LanguageFAB />
  </div>
</template>

<style scoped>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  margin-top: 100px; /* Adjusted for the new floating modern navbar */
}
</style>
